import { Video } from '@graphql/index';
import { VideoEmbedProps } from '@stadionhq-v3/base-ui';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { ContentfulImage } from '@stadionhq-v3/contentful-ui';
import { Play } from '@components/icons';
import Image from 'next/image';
import {
  getVideoThumbnailUrl,
  getVideoTitle,
} from '@utils/transforms/video/videoFieldFallbacks';

const videoEmbedTransform = (
  videoEntry: CleanContentful<Video>
): VideoEmbedProps => {
  const title = getVideoTitle(videoEntry);
  const thumbnailUrl = getVideoThumbnailUrl(videoEntry);

  return {
    image: videoEntry?.image ? (
      <ContentfulImage {...videoEntry.image} />
    ) : (
      <Image
        alt={title || 'Video'}
        layout="fill"
        objectFit="cover"
        src={thumbnailUrl || ''}
      />
    ),
    subTitle: videoEntry?.subtitle ?? undefined,
    videoTitle: title,
    video: {
      ...videoEntry?.video,
      videoId: videoEntry?.video?.id,
      endeavorRealmId: process.env.NEXT_PUBLIC_ENDEAVOR_REALM_ID,
      endeavorEmbedConfigId: process.env.NEXT_PUBLIC_ENDEAVOR_EMBED_CONFIG_ID,
      cardIcon: { icon: <Play /> },
      duration: { text: videoEntry?.video?.duration },
    },
  };
};

export default videoEmbedTransform;
